exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-main{max-width:none!important}", "", {"version":3,"sources":["F:/myugfront/src/pages/exam-view.vue"],"names":[],"mappings":"AACA,UAAU,wBAAyB,CAClC","file":"exam-view.vue","sourcesContent":["\n.btn-main{max-width:none !important\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/exam-view.vue
// module id = 1011
// module chunks = 26